import {
  Button,
  Card,
  CardActions,
  CardContent,
  Stack,
  Typography,
} from "@mui/material";
import { formatDate } from "../../../../../infrastructure/utils/formatters";
import ContractorStatusBadge from "./ContractorStatusBadge";

const DefectCard = ({
  defect,
  onResolve,
  resolving = false,
  evidenceReady = false,
}) => {
  if (!defect) return null;

  return (
    <Card
      variant="outlined"
      data-testid={`defect-card-${defect.id}`}
      sx={{ height: "100%" }}
    >
      <CardContent>
        <Stack spacing={1}>
          <Typography variant="subtitle1" fontWeight={700}>
            {defect.title || `ایراد #${defect.id}`}
          </Typography>
          {defect.description ? (
            <Typography variant="body2">{defect.description}</Typography>
          ) : null}
          <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
            <ContractorStatusBadge
              status={defect.severity}
              statusTitle={defect.severityTitle || "شدت"}
              label={defect.severityTitle || "شدت نامشخص"}
            />
            <ContractorStatusBadge
              status={defect.status}
              statusTitle={defect.statusTitle}
            />
          </Stack>
          {defect.createdAt ? (
            <Typography variant="caption" color="text.secondary">
              ثبت: {formatDate(defect.createdAt)}
            </Typography>
          ) : null}
        </Stack>
      </CardContent>
      <CardActions sx={{ px: 2, pb: 2 }}>
        {defect.canResolve ? (
          <Button
            size="small"
            variant="contained"
            disabled={resolving || !evidenceReady}
            onClick={() => onResolve?.(defect)}
            data-testid={`defect-resolve-${defect.id}`}
          >
            اعلام رفع ایراد
          </Button>
        ) : null}
      </CardActions>
    </Card>
  );
};

export default DefectCard;
